import React, {Fragment, useEffect, useRef, useState} from 'react';
import withRoot from "../../../withRoot";
import CheckoutCotizar from "./Checkout";
import Header from "../../../adviser/Dashboard/Header";
import Title from "../../../customer/ProductsCustomer/Title";
import CotizacionSuccess from "./Checkout/CotizacionSuccess"
import {Typography} from "@material-ui/core";
import Loading from "../../../Loading";
import ByPolko from "../../../customer/ByPolko";
import useStyles from "./Checkout/styles";

function Cotizar(props) {

    const classes = useStyles();
    const [finalValues, setFinalValues] = useState(null);
    const [cotizacionResponse, setCotizacionResponse] = useState(null);
    const [isCotizando, setIsCotizando] = useState(false);
    const [isCotizarDone, setIsCotizarDone] = useState(false);

    function currencyFormat(num) {
        return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    }

    const handleEndCotizar = (finalValues, cotizacionResponse) => {
        setFinalValues(finalValues);
        cotizacionResponse['detalleCoberturas']["obligatorias"].sort((a, b) => parseInt(a.numeroCobertura) - parseInt(b.numeroCobertura));
        cotizacionResponse['detalleCoberturas']["adicionales"].sort((a, b) => parseInt(a.numeroCobertura) - parseInt(b.numeroCobertura));

        cotizacionResponse['detalleCoberturas']["obligatorias"].map((cobertura) => {
            cobertura.sumaAseguradaText = currencyFormat(cobertura.sumaAsegurada)
        })
        cotizacionResponse['detalleCoberturas']["adicionales"].map((cobertura) => {
            cobertura.sumaAseguradaText = currencyFormat(cobertura.sumaAsegurada)
        })

        setCotizacionResponse(cotizacionResponse);
        setIsCotizarDone(true);
    }

    let myRef = useRef(null);

    useEffect(() => {
        if (myRef.current !== null && isCotizando) {
            myRef.current.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
    }, [isCotizando, myRef])
    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    backgroundColor: "#F5F6F9",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                    }}
                >
                    <Header role={"Asesor"}/>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        marginBottom: "50px"
                    }}
                >
                    <Title
                        title={"SEGUROS"}
                        subtitle={"¡Cotice un seguro de hogar en 2 pasos!"}
                    />
                </div>

                <div>
                    {typeof props.location.state !== 'undefined'
                        ? (<CheckoutCotizar
                            action={props.location.state.action}
                            cotizacionRetomada={props.location.state.action !== null}
                            handlerEndCotizacion={handleEndCotizar}
                            setIsCotizando={setIsCotizando}
                            setIsCotizarDone={setIsCotizarDone}
                            cotizacionValues={props.location.state.data}/>)
                        : (<CheckoutCotizar
                            cotizacionRetomada={false}
                            handlerEndCotizacion={handleEndCotizar}
                            setIsCotizando={setIsCotizando} setIsCotizarDone={setIsCotizarDone}
                            cotizacionValues={null}
                        />)}
                </div>
                {isCotizando === true
                    ? isCotizarDone === true
                        ? (<div className={classes.formBox} style={{marginTop: "40px"}}>
                            {props.location.state === undefined ?
                                <CotizacionSuccess finalValues={finalValues} cotizacionResponse={cotizacionResponse}/>
                                : <CotizacionSuccess finalValues={finalValues} cotizacionResponse={cotizacionResponse}
                                                     customerData={props.location.state.data.Clientes}/>
                            }

                        </div>)
                        : (
                            <div ref={myRef} className={classes.formBox} style={{marginTop: "40px"}}>
                                <Fragment>
                                    <Typography variant="h6" gutterBottom>
                                        Cotizando. Por favor espere...
                                    </Typography>
                                    <Loading/>
                                </Fragment>
                            </div>
                        )
                    : <div/>
                }

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        marginBottom: "80px"
                    }}
                >

                    <ByPolko fontSize={25}/>

                </div>
            </div>
        </React.Fragment>
    )
}

export default withRoot(Cotizar);
